module.exports = __webpack_public_path__ + "img/icon_inspect_overdue.44ef7d63.png";